import React from "react";
import {CCol, CFormInput, CFormLabel, CFormText, CRow} from "@coreui/react";
import {useDispatch, useSelector} from "react-redux";
import {applyFilter} from "../../store/slice/component/table";
import DatePicker from "react-date-picker";

const MemoApprovedSearch = () => {
    const dispatch = useDispatch([]);
    const data = useSelector(state => state.entities.component_table);
    let getDate = () => {
        if (data.approved_at) {
            return new Date(data.approved_at);
        }
        return '';
    };
    return <>
        <CRow className={'mt-1'}>
            <CCol sm={12} md={6}>
                <CFormLabel>Approved By</CFormLabel>
                <CFormInput type="text"
                            onChange={(e) => {
                                dispatch(applyFilter({
                                    field_name: 'approved_by_name',
                                    value: e.target.value,
                                }));
                            }}
                            defaultValue={data.approved_by_name || ''}
                />
                <CFormText>Example: Suresh Nai, Mahesh Mistry</CFormText>
            </CCol>
            <CCol sm={12} md={6}>
                <CFormLabel>Approved Time Stamp</CFormLabel>
                <DatePicker
                    onChange={(e) => {
                        dispatch(applyFilter({
                            field_name: 'approved_at',
                            value: e,
                        }));
                    }}
                    value={getDate() || ''}
                    className={'form-control'}
                />
            </CCol>
        </CRow>
    </>;
}

export default MemoApprovedSearch;
